import { useMediaQuery, useTheme } from '@material-ui/core'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { setInitialState } from '../../../store/home-page-items/reducer'
import { useAppHeaderLogoStyles } from './app-header-logo.styles'

type StyleProps = {
  resetOffset?: boolean
  /** White logos on narrow screens (e.g. primary AppBar on main page mobile) */
  variant?: 'default' | 'onPrimary'
}

export const AppHeaderLogo: React.FC<StyleProps> = (
  props
): React.ReactElement => {
  const { resetOffset, variant = 'default' } = props
  const classes = useAppHeaderLogoStyles()
  const theme = useTheme()
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()

  const useWhiteLogos = variant === 'onPrimary' && isSmDown
  const logoSrc = useWhiteLogos ? '/images/logo-white.svg' : '/images/logo-black.svg'
  const miniSrc = useWhiteLogos ? '/images/logo-white.svg' : '/images/logo-mini.svg'

  const onClickHandler = () => {
    dispatch(setInitialState())
  }
  return (
    <Link
      to="/"
      className={
        resetOffset
          ? [classes.root, classes.resetOffset].join(' ')
          : [classes.root].join(' ')
      }
      onClick={onClickHandler}
    >
      <img src={logoSrc} className={classes.logo} alt="" />
      <img
        src={miniSrc}
        className={
          useWhiteLogos ? classes.logoMiniWordmark : classes.logoMini
        }
        alt=""
      />
    </Link>
  )
}
